import { type FC, useEffect, useState } from "react";

import { SelectedAddressView, SelectedAddressViewCard } from "@jti/commerce";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

import type { CustomShippingOptionWidgetVariantsCommonProps } from "../../CustomShippingOptionWidget.types";
import { prepareAddressViewFormat } from "../../utils/prepareAddressViewFormat";

type Props = Pick<CustomShippingOptionWidgetVariantsCommonProps, "children" | "selectedAddress" | "widgetError">;

export const CustomShippingOptionWidgetVariantEmbeddedIterationTwo: FC<Props> = ({
  selectedAddress,
  children,
  widgetError,
}) => {
  const { __ } = useTranslations();
  const [displayState, setDisplayState] = useState<"widget" | "address">(selectedAddress ? "address" : "widget");

  useEffect(() => {
    setDisplayState(selectedAddress ? "address" : "widget");
  }, [selectedAddress]);

  return (
    <>
      {widgetError?.code && <AlertBanner tone="error" data-testid="widget-error" description={widgetError.message} />}

      <div style={displayState === "widget" ? undefined : { display: "none" }}>{children}</div>

      {displayState === "address" && !!selectedAddress && (
        <SelectedAddressViewCard
          title={__("cart.checkout.delivery.custom.title")}
          changeBtnText={__("cart.checkout.delivery.custom.change_cta")}
          onChange={() => setDisplayState("widget")}
        >
          <SelectedAddressView title={selectedAddress.storeName} address={prepareAddressViewFormat(selectedAddress)} />
        </SelectedAddressViewCard>
      )}
    </>
  );
};
